import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import ButtonComponent from '../button';
import { NotFoundWrapper } from './404-not-found.style';

const NotFound404 = ({
    label = '404',
    text, // e.g: OOPS! PAGE NOT FOUND
    showButton, // true or false
    buttonLabel, // e.g: Go back
    buttonPath, // e.g: /login
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (buttonPath) {
            navigate(buttonPath);
        }
    };

    return (
        <NotFoundWrapper>
            <h2>{label}</h2>
            {
                text &&
                <p>{text}</p>
            }
            {
                showButton && (
                    <ButtonComponent label={buttonLabel} outline onClick={handleClick} />
                )
            }
        </NotFoundWrapper>
    );
};

NotFound404.propTypes = {
    label: PropTypes.string,
    text: PropTypes.string,
    showButton: PropTypes.bool,
    buttonLabel: PropTypes.string,
    buttonPath: PropTypes.string,
};

export default NotFound404;